module.exports = __webpack_public_path__ + "static/media/YM57_2.699ed075.jpg";